import { TimelineItemStatus } from '@components'

import { InvoiceEventType } from '@features/invoices/enums/invoiceEventType'

export const getTimelineStatusByInvoiceEventType = (event: string): TimelineItemStatus => {
  switch (event) {
    case InvoiceEventType.DeliveryBaswareEinvoiceNotification:
    case InvoiceEventType.DeliveryPublicDeBaswareEinvoiceNotification:
    case InvoiceEventType.DeliveryPublicFrBaswareEinvoiceNotification:
    case InvoiceEventType.DocumentIntegrationCpaToolsCreateRequestSuccess:
    case InvoiceEventType.DocumentReminderEmailSent:
      return 'success'
    case InvoiceEventType.DeliveryBaswareEinvoiceFailureEmail:
    case InvoiceEventType.DeliveryEmailCaptchaFailed:
    case InvoiceEventType.DeliveryEmailComplained:
    case InvoiceEventType.DeliveryEmailDropped:
    case InvoiceEventType.DeliveryEmailEinvoiceFailedSubject:
    case InvoiceEventType.DeliveryEmailEmailFailedSubject:
    case InvoiceEventType.DeliveryEmailFailed:
    case InvoiceEventType.DeliveryEmailPaperFailedSubject:
    case InvoiceEventType.DeliveryReminderEmailComplained:
    case InvoiceEventType.DeliveryReminderEmailDropped:
    case InvoiceEventType.DeliveryReminderEmailFailed:
    case InvoiceEventType.DeliveryReminderEmailNotsent:
    case InvoiceEventType.DocumentIntegrationCpaToolsCreateRequestRejected:
      return 'error'
    default:
      return 'neutral'
  }
}
